import styles from './PortfolioNavigation.module.css';

const unprocessedTooltipText =
  'Unprocessed new applications that are available to be assigned to portfolio. ';

export function UnprocessedTooltipUser() {
  return (
    <div className={styles.textTooltip}>
      <p>{unprocessedTooltipText}</p>
    </div>
  );
}
